import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';
import MediaCard from '../components/MediaCard';
import { Library, BookOpen, Video, Podcast, Film } from 'lucide-react';
import { Button } from '../components/ui/button';

const mediaTypes = [
  { id: null, label: 'All', icon: Library },
  { id: 'book', label: 'Books', icon: BookOpen },
  { id: 'video', label: 'Videos', icon: Video },
  { id: 'podcast', label: 'Podcasts', icon: Podcast },
  { id: 'documentary', label: 'Documentaries', icon: Film },
];

export default function MediaPage() {
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeType, setActiveType] = useState(null);

  useEffect(() => {
    const fetchMedia = async () => {
      setLoading(true);
      try {
        const params = activeType ? `?media_type=${activeType}` : '';
        const res = await axios.get(`${API}/media${params}`);
        setMedia(res.data);
      } catch (error) {
        console.error('Error fetching media:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchMedia();
  }, [activeType]);

  return (
    <div className="min-h-screen py-12 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <Library className="w-8 h-8 text-cyan-400" />
            <h1 className="font-heading text-3xl md:text-5xl font-bold" data-testid="media-title">
              Book & Media Library
            </h1>
          </div>
          <p className="text-white/50 max-w-2xl">
            Essential books, videos, and documentaries on paranormal phenomena, government programs, and consciousness research.
          </p>
        </div>

        {/* Type Filter */}
        <div className="flex flex-wrap gap-2 mb-8">
          {mediaTypes.map((type) => {
            const Icon = type.icon;
            return (
              <Button
                key={type.id || 'all'}
                variant={activeType === type.id ? 'default' : 'ghost'}
                className={`flex items-center gap-2 ${
                  activeType === type.id 
                    ? 'bg-white text-black' 
                    : 'text-white/60 hover:text-white'
                }`}
                onClick={() => setActiveType(type.id)}
                data-testid={`filter-${type.label.toLowerCase()}`}
              >
                <Icon className="w-4 h-4" />
                {type.label}
              </Button>
            );
          })}
        </div>

        {/* Media Grid */}
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="skeleton h-80 rounded-sm" />
            ))}
          </div>
        ) : media.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-white/50">No media items found.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="media-grid">
            {media.map(item => (
              <MediaCard key={item.media_id} media={item} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
